module.exports = __webpack_public_path__ + "static/media/Impreza-Blob-GG-Wagon.58c27a86.jpeg";